<template>
  <div
    class="chat-container pt-3 d-flex flex-column align-items-start justify-content-flex-start"
  >
    <b-container class="messages-container">
      <b-row
        v-if="messages.length"
        ref="messagesList"
        class="messages-row pr-3 pl-3"
        :class="{ spacing: messages.length < 4 }"
      >
        <b-col
          v-for="(message, index) in messages"
          :key="message._id"
          class="col-12 p-0 pt-3 pb-1 message-item"
          :class="{
            separator: index != messages.length - 1,
          }"
        >
          <h2>{{ message.sender.name }}</h2>
          <div class="d-flex flex-row">
            <div class="mb-1 pr-2 message-text-container">
              <p class="message-text">
                {{ message.message }}
              </p>
            </div>
            <div class="text-right">
              <span class="timestamp-text">{{
                formatMessageTimestamp(message.timestamp)
              }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-else class="messages-row">
        <b-col class="col-12">
          <b-img fluid :src="require('@/assets/Ao-Vivo/Search-rafiki.png')" />
        </b-col>
        <b-col class="col-12 text-center no-messages">
          <span>Nenhuma mensagem encontrada...</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pl-0 pt-1">
          <b-form-checkbox
            v-model="rolagemAutomatica"
            name="check-button"
            class="check-scroll"
            switch
          >
            <span class="txt-rolagem">
              Rolagem automática
            </span>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="send-message-row pt-2">
      <b-row>
        <b-col class="col-9 pr-0">
          <b-form-textarea
            size="sm"
            no-resize
            placeholder="Digite aqui sua mensagem..."
            v-model="message"
            @keyup.enter="onSend"
          />
        </b-col>
        <b-col class="col-3 my-auto">
          <b-button class="btn-hover color-1" @click="onSend">
            <b-spinner v-if="sending" variant="white" small />
            <b-icon v-else icon="check" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { getMessages, sendMessage } from "@/services/api/Chat";
import { GetCookie } from "@/utils/CookieUtil";
import jwt_decode from "jwt-decode";
import moment from "moment";

export default {
  name: "Chat",
  props: {
    idPalestra: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      messages: [],
      sending: false,
      loading: true,
      rolagemAutomatica: true,
      message: "",
      uid: "",
    };
  },
  methods: {
    getSenderName({ sender }) {
      return sender._id == this.uid ? "Você" : sender.name;
    },
    formatMessageTimestamp(timestamp) {
      const date = new Date(timestamp);
      const newDate = moment(date).format("HH:mm");
      return `${newDate}`;
    },
    scrollToBottom() {
      if (this.rolagemAutomatica)
        this.$refs.messagesList.scrollTop = this.$refs.messagesList.scrollHeight;
    },
    loadMessages() {
      this.loading = true;
      return getMessages(this.idPalestra)
        .then((res) => {
          this.messages = res.data;
          this.loading = false;
          this.scrollToBottom();
        })
        .catch((err) => {
          console.error("Erro ao obter mensagens", err);
          this.loading = false;
        });
    },
    onSend() {
      this.message = this.message.replace("\n", "");
      if (!this.message || this.message.trim().length == 0) return false;
      this.sending = true;
      sendMessage(this.idPalestra, this.message)
        .then(() => {
          this.loadMessages().then(() => {
            this.message = "";
            this.sending = false;
            this.scrollToBottom();
          });
        })
        .catch((err) => {
          console.error("Error sending message", err);
          this.sending = false;
          alert("Erro ao enviar messagem. Tente novamente.");
        });
    },
  },

  created() {
    this.uid = jwt_decode(GetCookie("token")).uid;
    this.loadMessages();
    setInterval(() => {
      this.loadMessages();
    }, 2 * 1000);
  },
};
</script>

<style lang="scss" scoped>
.chat-container {
  background-color: rgb(240, 243, 247) !important;
  border-radius: 5px;
  height: 410px;
}
.messages-container {
  height: 80%;
  padding: 0px 30px;
}
.no-messages {
  color: #777;
  margin-top: -30px;
}
.spacing {
  padding-bottom: 100px;
}
.messages-row {
  height: 92%;
  max-height: 92%;
  border-radius: 5px;
  background-color: #fff;
  overflow-y: scroll;
  scroll-behavior: smooth;
  .separator {
    border-bottom: 1px solid #ccc;
  }
  .message-item {
    h2 {
      color: #333;
      font-size: 0.9rem;
    }
    .message-text-container {
      flex-grow: 1;
    }
    .message-text {
      width: 90%;
      overflow-wrap: break-word;
      word-wrap: break-word;
      -webkit-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
    }
    .timestamp-text {
      font-size: 0.85rem;
    }
  }
}

.send-message-row {
  height: 20%;
}

.btn-hover {
  border: none;
  background-size: 300% 100%;

  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.txt-rolagem {
  font-size: 0.95rem;
}

.btn-hover:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-1 {
  background-image: linear-gradient(to right, #ffc107, #ff0000, #ff0068);
  box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}
</style>

<style lang="scss">
.check-scroll {
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #ff6e04;
    border-color: #ff6e04;
  }
}
</style>
